import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertParseDateTime,
  convertParseDateTimeLangSpecific,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { IAccessDetail } from '../../../user-management/user-management-interfaces';
import { accessLevelResponse } from 'src/app/shared/constants/response-mapping';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { enUS, fr } from 'date-fns/locale';

@Component({
  selector: 'app-user-list-items',
  templateUrl: './user-list-items.component.html',
  styleUrls: ['./user-list-items.component.scss'],
})
export class UserListItemsComponent implements OnInit {
  @Input() listItems!: Array<IAccessDetail>;
  @Input() userType!: string;
  @Output() homeAccessOnClick? = new EventEmitter<string>();
  readonly LANG_CONST = LANG_CONST;
  readonly accessLevelResponse = accessLevelResponse;
  commonAccessControl!: boolean;
  sharedData?: ISharedData;
  CONSTANTS = CONSTANTS;
  locale = this.stateManagementService.getUserLanguage();
  constructor(private sharedDataService: SharedDataService, private stateManagementService: StateManagementService,private localizationService: LocalizationService) {}
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
  }
  onClickListner() {
    this.homeAccessOnClick?.emit('homeAccessOnClick');
  }

  splitIntoComma(item: IAccessDetail): string {
    const lang = this.locale === LANG_CONST.FRENCH ? fr : enUS;
    const days = (convertParseDateTimeLangSpecific(
          String(item.repeatDays),
          "EEEE",
          "EEEE",
          lang
        ))
    const repeatStartTime = convertParseDateTime(
      item.repeatStartTime!,
      'HH:mm',
      'hh:mm a'
    );
    const repeatEndTime = convertParseDateTime(
      item.repeatEndTime!,
      'HH:mm',
      'hh:mm a'
    );
    return `${days} , ${repeatStartTime} - ${repeatEndTime}`;
  }
  /** * @description: This method perform convertParseDateTime function
   * * @param { Date }
   * * @output { Formated Date }   */
  getDate(date: string) {
    const response = convertParseDateTime(
      extractDateTimeFromDateString(String(date)),
      "yyyy-MM-dd'T'HH:mm:ss",
      'yyyy/MM/dd hh:mm a'
    );
    return response;
  }
}
